export function createAction (type, payload) {
  return {
    type,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/utils/redux/createAction.js